import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/es';

[
  utc,
  timezone,
  customParseFormat,
  quarterOfYear,
  isoWeek,
  isSameOrAfter,
  isSameOrBefore
].forEach(plugin => dayjs.extend(plugin));

dayjs.tz.setDefault('America/Mexico_City');
dayjs.locale('es');

export default dayjs;
